import { useAutocomplete } from 'admin';
import { AutocompleteField } from 'form';

type InspectionChoice = {
  id: number;
  slug: string;
  name: string;
};

type Props = {
  name: string;
  label?: string;
  required?: boolean;
  onSelectOption?: (value: InspectionChoice) => void;
};

export const InspectionAutocomplete = ({
  name,
  label = 'Select inspection',
  required = false,
  onSelectOption,
}: Props) => {
  const { autocompleteProps } = useAutocomplete<InspectionChoice>({
    dataProviderName: 'inspections',
    onSearch: (value) => [
      {
        field: 'search',
        operator: 'contains',
        value,
      },
    ],
    resource: '/v2/',
  });

  return (
    <AutocompleteField<InspectionChoice>
      {...autocompleteProps}
      name={name}
      label={label}
      valueField="id"
      required={required}
      getOptionLabel={(item) => item.slug}
      isOptionEqualToValue={(option, value) => {
        return value === undefined || option?.id?.toString() === (value?.id ?? value)?.toString();
      }}
      onSelectOption={onSelectOption}
      data-testid="inspection-autocomplete"
    />
  );
};
